import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";
import pastaSvg from "../../assets/icons/infoPasta.svg";
import {
  listarPastas,
  listarPastaFilha,
} from "../../services/http/pastaService";

import {
  registrarDownloadArquivo,
  registrarDownloadPasta,
  registrarVisualizacaoArquivo,
  registrarVisualizacaoPasta
} from "../../services/http/dashboardService";
import addMore from "../../assets/icons/addMore.png";
import services from "../../services";
import iconNuvemArquivoSvg from "../../assets/icons/iconNuvemArquivo.svg";
import iconNuvemArquivoSvgSelect from "../../assets/icons/iconNuvemArquivoSelecionado.svg";
import ModalNovaPasta from "../ModalNovaPasta";
import { Modal, message, Radio } from "antd";

import PastaSelecionado from "../../assets/icons/pasta-menu-selecionado.svg";
import PastaIc from "../../assets/icons/pasta-menu.svg";
import "./styles.scss";
import ArvorePasta from "./ArvorePastas";
import { CloseOutlined } from "@mui/icons-material";

const initTreeData = [
  {
    title: "Nuvem de arquivos",
    key: "0/NuvemArquivo",
    icon: <img src={iconNuvemArquivoSvg} />,
  },
]; 

const ModalListaPastas = ({ 
  closeModal,
  openModal,
  setPastas,
  pastas,
  setIncluirSubPastas,
  incluirSubPastas,
}) => {
  const { IdUser } = services.storage.getUser();
  const [data, setData] = useState([]);
  const [titulos, setTitulos] = useState([]);
  const [avatarPasta, setavatarPasta] = useState([]);
  const [avatarPastaRemoved, setavatarPastaRemoved] = useState([]);
  const [treeData, setTreeData] = useState(initTreeData);
  const [loading, setLoading] = useState(false);
  const [expandedKeys, setExpandedKeyss] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [modalNovaPasta, setModalNovaPasta] = useState(false);
  const [historicoSelecao, setHistoricoSelecao] = useState({
    pos: null,
    historico: [],
  });
  const [showTreeData, setShowTreeData] = useState(true);
  const [expadendAll, setExpanddAll] = useState(true);
  const [selectedKeys, setSelectedKeys] = useState([]);
  let array = [];
  const [paginacaoInfo, setPaginacaoInfo] = useState({
    hasNextPage: false,
    hasPreviousPage: false,
    page: 1,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    const updatedTreeData = [...treeData];
    const cloudNodeIndex = updatedTreeData.findIndex(
      (node) => node.key === "0/NuvemArquivo"
    );

    if (cloudNodeIndex !== -1) {
      const icon = selectedKeys.includes("0/NuvemArquivo")
        ? iconNuvemArquivoSvgSelect
        : iconNuvemArquivoSvg;
      updatedTreeData[cloudNodeIndex].icon = <img src={icon} />;
      setTreeData(updatedTreeData);
    }
  }, [selectedKeys]);
  const pastaSelecionada = (value) => {
    setSelectedKeys(value);
    if (value[0] !== "0") {
      var pastas = [];
      var pasta = {};
      if (value.length == 1) {
        var item = value[0].split("/");
        pasta = { id: item[0], nome: item[1] };
        pastas.push(pasta);
      } else {
        value.forEach((item) => {
          var pastaResult = item.split("/");
          pasta = { id: pastaResult[0], nome: pastaResult[1] };
          pastas.push(pasta);
        });
      }
      setavatarPasta([...pastas]);

      const pastaElement = document.getElementById(value[0]);
      if (pastaElement) {
        pastaElement.classList.add("pasta-selecionada");
      }
    }
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };
  const showIniciais = (nome) => {
    if (nome.length > 11) {
      var pastaName = nome.substring(0, Math.min(nome.length, 11));
      return pastaName + "...";
    }

    return nome;
  };

  const montarTitulos = (item) => {
    item.forEach((element) => {
      array.push({
        title: element.title,
        key: element.key,
      });
      if (element?.children.length > 0) {
        montarTitulos(element?.children);
      }
    });

    return array;
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return { ...node, children };
      }

      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }

      return node;
    });
  };

  const pastaselecionados = () => {
    setPastas(avatarPasta);
    closeModal();
  };
  const onChange = (e) => {
    setIncluirSubPastas(e.target.value);
  };
  const OpenModalNovaPasta = () => {
    if (avatarPasta.length > 1) {
      message.info("Selecione apenas uma única pasta");
    } else {
      setModalNovaPasta(true);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => { 
      onLoadData({ key: "1" });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };
  const onLoadData = ({ key, children }) =>
    new Promise((resolve) => {
    
      setLoading(true);
      if (key.split("/")[0] == "0") {
        trackPromise(
          listarPastas(IdUser, 1, 1000)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];
                res.data.lista.forEach((element) => {
                  array.push({
                    title: formatNomePasta(element.nome),
                    key: `${element.id}/${element.nome}`,
                  });
                });

                setTreeData((origin) => updateTreeData(origin, key, array));
              }
              setLoading(false);
              resolve();
            })
            .catch((error) => {
              console.error(error);
            })
        );
      } else {
        setLoading(true);
        let [idPastaSelecionada, nomePastaSelecionada] = key.split("/");
        trackPromise(
          listarPastaFilha(idPastaSelecionada)
            .then((res) => {
              if (!res.fail && res.data) {
                let array = [];

                res.data.forEach((element) => {
                  if (element.tipo == 0) {
                    array.push({
                      title: formatNomePasta(element.nome),
                      key: `${element.id}/${element.nome}`,
                    });
                  }
                });
                setTreeData((origin) => updateTreeData(origin, key, array));
                registrarVisualizacaoPastas(idPastaSelecionada);
                setLoading(false);
                resolve();
              } else {
                resolve();
              }
            })
            .catch((error) => {
              console.error(error);
            })
        );
      }
    });

  const expanded = (expandedKeys, obj) => {
    if (obj?.node?.key != "0") {
      let testando = {};
      if (
        historicoSelecao.pos == null ||
        obj?.node?.pos.substring(4, 5) !=
          historicoSelecao?.historico[0]?.pos.substring(4, 5)
      ) {
        setHistoricoSelecao({ pos: null, historico: [] });
        testando = {
          pos: obj?.node?.pos,
          historico: [],
        };
      } else {
        testando = {
          historico: historicoSelecao.historico,
        };
      }

      let [idPastaSelecionada, nomePastaSelecionada] =
        obj?.node?.key.split("/");

      let novaPasta = {
        name: nomePastaSelecionada,
        id: idPastaSelecionada,
        pos: obj?.node?.pos,
      };

      if (
        !historicoSelecao?.historico?.some((x) => x.id == idPastaSelecionada)
      ) {
        testando.historico.push(novaPasta);
      }

      if (historicoSelecao.pos == null) {
        setHistoricoSelecao((prevState) => testando);
      }
    }
  };
  return (
    <div>
      <Modal
        title={<span className="modal-title-novo ">Adicionar pastas</span>}
        visible={openModal}
        className="modal-novo custom-modal"
        closable={false}
        footer={[
          <div >
            <div className="row justify-content-center">
              <button
                onClick={() => OpenModalNovaPasta()}
                className="button-modal-novo mb-5"
              >
                <img src={addMore} /> NOVA PASTA
              </button>
            </div>

            <button
              onClick={closeModal}
              className="button-modal-novo"
              style={{ marginRight: "45px" }}
            >
              CANCELAR
            </button>
            <button
              className="buttonConfirmar-modal-novo"
              onClick={() => pastaselecionados()}
            >
              Ok
            </button>
          </div>,
        ]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <div className="fundoModal">
          <div className="row espacoInterno">
            <div className="col-md-4 col-sm-4 col-xl-4 itensPastas">
              Itens selecionados:
            </div>
            <div className="col-md-8 col-sm-8 col-xl-8">
              <div className="row card-user-avatar">
                {avatarPasta &&
                  avatarPasta?.map((item, index) => (
                    <div
                      key={item.id}
                      className="col-md-6 col-sm-6 col-xl-6 mt-2"
                    >
                      <span className="avatar-item">
                        <img src={pastaSvg} style={{ marginRight: "5px" }} />
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          {showIniciais(item.nome)}
                        </span>
                      </span>
                    </div>
                  ))}
              </div>
            </div>
            <div className="itensPastas mt-5 pl-3 pr-2">
              Incluir sub-pastas e arquivos:
            </div>
            <div className=" mt-5">
              <Radio.Group onChange={onChange} value={incluirSubPastas}>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </div>
          </div>
        </div>

        {
          <div className="espacoInternoArvore">
            <span className="minhasPastas">Minhas pastas</span>

            <ArvorePasta
              className="arvorePasta"
              treeData={treeData}
              expadendAll={expadendAll}
              pastaSelecionada={pastaSelecionada}
              expandedKeys={expandedKeys}
              searchValue={searchValue}
              showTreeData={showTreeData}
              autoExpandParent={autoExpandParent}
              setExpandedKeyss={setExpandedKeyss}
              setAutoExpandParent={setAutoExpandParent}
              loadData={onLoadData}
              expanded={expanded}
            />
          </div>
        }
      </Modal>

      <ModalNovaPasta
        pastaDestino={avatarPasta[0]?.id}
        closeModal={setModalNovaPasta}
        openModal={modalNovaPasta}
        setExpanddAll={setExpanddAll}
        setShowTreeData={setShowTreeData}
      />
    </div>
  );
};

export default ModalListaPastas;
